module.exports = __webpack_public_path__ + "static/media/niccolo_duina.ad695ac5.png";